import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams, useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import KeyboardBackspaceOutlinedIcon from "@mui/icons-material/KeyboardBackspaceOutlined";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { makeStyles } from "@material-ui/core";
import CurrencyInput from "react-currency-input-field";
import {
  TextField,
  InputLabel,
  Input,
  Button,
  Autocomplete,
} from "@mui/material";
import { detailsRecord, updateRecord } from "../actions/VivoFinanceActions";
import LoadingBox from "../components/LoadingBox";
import MessageBox from "../components/MessageBox";
import categories from "../assets/data/categories.json";
import Notification from "../components/Notification";
import { RECORD_UPDATE_RESET } from "../constants/financeConstants";
import styles from "assets/jss/vivoleo-react-kit/views/componentsSections/addRecordScreenStyle";

const useStyles = makeStyles(styles);

export default function RecordEditScreen(props) {
  const classes = useStyles();

  const { id } = useParams();
  const recordId = id;
  console.log("recordId:" + recordId);

  const recordDetails = useSelector((state) => state.recordDetails);

  const [selectedDate, setSelectedDate] = useState(new Date());

  const [description, setDescription] = useState("");
  const [invoiceamount, setInvoiceamount] = useState("");
  const [currency, setCurrency] = useState("");
  const [category, setCategory] = useState("");
  const [inoivcefile, setInoivcefile] = useState("");
  const [paymentmethod, setPaymentmethod] = useState("");
  const [paymentdate, setPaymentdate] = useState("");
  const [paydate, setPaydate] = useState("");
  const [payby, setPayby] = useState("");
  const [payto, setPayto] = useState("");
  const [otherinfo, setOtherinfo] = useState("");
  const [notify, setNotify] = useState({
    isOpen: false,
    message: "",
    type: "",
  });
  /*
  const redirect = props.location.search
    ? props.location.search.split('=')[1]
    : '/';
*/
  const navigate = useNavigate();
  // const { requrl }= useParams();
  /** The current relative URL (pathname + search + hash). */
  /*
 const requrl = ()=> {
   const loc = props.location;
   return loc.pathname + loc.search + loc.hash;
  };
 const redirect = requrl.search
 ? requrl.search.split('=')[1]
 : '/';
*/
  // const redirect = '/addfinancerec';
  /*
  const recordCategoryList = useSelector((state) => state.recordCategoryList);
  const {
    loading: loadingCategories,
    error: errorCategories,
    categories,
  } = recordCategoryList;

*/
  console.log("categories:" + categories);

  const { loading, error, record } = recordDetails; //use previous records
  const recordUpdate = useSelector((state) => state.recordUpdate);

  const {
    loading: loadingUpdate,
    error: errorUpdate,
    success: successUpdate,
  } = recordUpdate;

  const dispatch = useDispatch();

  useEffect(() => {
    if (successUpdate) {
      //props.history.push('/recordlist');
      //navigate("/recordlist", { replace: true });
      navigate(-1);
    }
    if (!record || record._id !== recordId || successUpdate) {
      dispatch({ type: RECORD_UPDATE_RESET });
      dispatch(detailsRecord(recordId));
    } else {
      setDescription(record.description);
      setInvoiceamount(record.invoiceamount);
      setCurrency(record.currency);
      setCategory(record.category);
      setInoivcefile(record.inoivcefile);
      setPaymentmethod(record.paymentmethod);
      setPaymentdate(record.paymentdate);
      setPayby(record.payby);
      setPayto(record.payto);
      setOtherinfo(record.otherinfo);
      setPaydate(record.paydate);
    }
  }, [record, dispatch, recordId, successUpdate, props.history]);

  const submitHandler = (e) => {
    e.preventDefault();
    // TODO: dispatch update record
    dispatch(
      updateRecord({
        _id: recordId,
        description,
        invoiceamount,
        currency,
        category,
        inoivcefile,
        paymentmethod,
        paymentdate,
        payby,
        payto,
        otherinfo,
        paydate,
      })
    );
  };

  const userSignin = useSelector((state) => state.userSignin);
  const { userInfo } = userSignin;

  /*
  useEffect(() => {
    if (userInfo) {
      props.history.push(redirect);
    }
  }, [props.history, redirect, userInfo]);
*/

  const handleSelectChange = (e) => {
    setCategory(e.target.value);
    console.log("selected category:" + category);
  };
  const handleSelectedDate = (newDate) => {
    setSelectedDate(newDate);
    // setPaymentdate(newDate);
    setPaydate(newDate);
    console.log("pay date:" + paydate);
  };

  const handlePayDate = (newDate) => {
    setPaydate(newDate);
    setPaymentdate(
      newDate.getDate() +
        "/" +
        parseInt(newDate.getMonth() + 1) +
        "/" +
        newDate.getFullYear()
    );
    console.log("pay  date:" + paydate);
  };

  return (
    <div>
      <div className={classes.space30}> </div>
      <Button
        variant="outlined"
        className="medium"
        startIcon={<KeyboardBackspaceOutlinedIcon sx={{ color: "#E91E63" }} />}
        onClick={() => navigate(-1)}
      >
        Back
      </Button>
      <Button variant="outlined" size="medium">
        <Link to="/recordlist">Record List</Link>
      </Button>
      <div className={classes.textCenter}>
        <h1>Update Finance Record</h1>
      </div>
      <form className="form" onSubmit={submitHandler}>
        {loadingUpdate && <LoadingBox></LoadingBox>}
        {errorUpdate && <MessageBox variant="danger">{errorUpdate}</MessageBox>}
        {loading ? (
          <LoadingBox></LoadingBox>
        ) : error ? (
          <MessageBox variant="danger">{error}</MessageBox>
        ) : (
          <>
            <div>
              <InputLabel htmlFor="description">Description</InputLabel>
              <Input
                fullWidth={true}
                multiline={true}
                id="description"
                placeholder="Enter description"
                defaultValue={description}
                onChange={(e) => setDescription(e.target.value)}
              ></Input>
            </div>
            <div className={classes.space30}> </div>
            <div>
              <InputLabel htmlFor="invoiceamount">Invoice Amount</InputLabel>
              <CurrencyInput
                id="invoiceamount"
                name="invoiceamount"
                placeholder="Enter invoice amount"
                value={Number(invoiceamount)}
                decimalsLimit={2}
                fixedDecimalLength={2}
                onValueChange={(value, name) => setInvoiceamount(Number(value))}
              />
            </div>
            <div className={classes.space30}> </div>
            {/* 
             <div>
              <label htmlFor="invoiceamount">Invoice Amount</label>
              <input
                type="number"
                id="invoiceamount"
                placeholder="Enter invoice amount"
                value={Number(invoiceamount).toFixed(2)}
                onChange={(e) => setInvoiceamount(e.target.value)}
              ></input>
            </div>           
            
            */}
            <div>
              <InputLabel htmlFor="currency">Currency</InputLabel>
              <Input
                id="currency"
                label="Currency"
                helperText="CAD, USD, RMB, EUR, BP"
                variant="standard"
                required
                defaultValue={currency}
                onChange={(e) => setCurrency(e.target.value)}
              >
                {currency}
              </Input>
            </div>
            <div className={classes.space30}> </div>
            <div>
              <TextField
                id="category"
                select
                label="Category"
                value={category}
                onChange={(e) => setCategory(e.target.value)}
                helperText="Please select right category"
                SelectProps={{
                  native: true,
                }}
              >
                {categories.map((x, id) => (
                  <option value={x.category} key={x.id}>
                    {x.category}
                  </option>
                ))}
              </TextField>
            </div>
            <div className={classes.space30}> </div>
            <div>
              <InputLabel htmlFor="inoivcefile">Inoivcefile</InputLabel>
              <Input
                fullWidth={true}
                multiline={true}
                id="inoivcefile"
                placeholder="Enter inoivcefile"
                defaultValue={inoivcefile}
                onChange={(e) => setInoivcefile(e.target.value)}
              ></Input>
            </div>
            <div className={classes.space30}> </div>
            <div>
              <InputLabel htmlFor="paymentmethod">Payment Method</InputLabel>
              <input
                type="paymentmethod"
                id="paymentmethod"
                placeholder="Enter payment method"
                value={paymentmethod}
                onChange={(e) => setPaymentmethod(e.target.value)}
              ></input>
            </div>
            <div className={classes.space30}> </div>
            <div>
              {/* 
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <Stack spacing={3}>
            <MobileDatePicker
            InputLabel="Payment Date(MM/DD/YYYY)"
            inputFormat="MM/dd/yyyy"
            value={selectedDate}
            onChange={handleSelectedDate}
            renderInput={(params) => <TextField {...params} />}
          />
          </Stack>
        </LocalizationProvider>
                    */}

              <InputLabel htmlFor="paymentdate">Payment Date</InputLabel>
              <input
                type="paymentdate"
                id="paymentdate"
                placeholder="Enter payment date"
                value={paymentdate}
                // onChange={(e) => setPaymentdate(e.target.value)}
              ></input>
            </div>
            <div className={classes.space30}> </div>
            <div>
              <InputLabel htmlFor="payby">Paid by whom</InputLabel>
              <input
                type="payby"
                id="payby"
                placeholder="David"
                value={payby}
                onChange={(e) => setPayby(e.target.value)}
              ></input>
            </div>
            <div className={classes.space30}> </div>
            <div>
              <InputLabel htmlFor="payto">Paid to whom</InputLabel>
              <input
                type="payto"
                id="payto"
                placeholder="Fido"
                value={payto}
                onChange={(e) => setPayto(e.target.value)}
              ></input>
            </div>
            <div className={classes.space30}> </div>
            <div>
              <InputLabel htmlFor="otherinfo">other information</InputLabel>
              <input
                type="otherinfo"
                id="otherinfo"
                placeholder="please add more information if needs"
                value={otherinfo}
                onChange={(e) => setOtherinfo(e.target.value)}
              ></input>
            </div>
            <div className={classes.space30}> </div>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <Stack spacing={3}>
                <MobileDatePicker
                  label="Payment Date(MM/DD/YYYY)"
                  inputFormat="MM/dd/yyyy"
                  value={paydate}
                  onChange={handlePayDate}
                  renderInput={(params) => <TextField {...params} />}
                />
              </Stack>
            </LocalizationProvider>
            <div className={classes.space30}> </div>
            <div>
              <InputLabel></InputLabel>
              <Button variant="contained" size="medium" type="submit">
                Update
              </Button>
            </div>
            <div className={classes.space30}> </div>
          </>
        )}
        {/*        
        <div>
          <label />
          <div>
            Already have an account?{' '}
            <Link to={`/signin?redirect=${redirect}`}>Sign-In</Link>
          </div>
        </div> 
    */}
      </form>
      <Notification notify={notify} setNotify={setNotify}></Notification>
    </div>
  );
}
